import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useEffect,
} from 'react'

interface WizardContextProps {
  activeStep: number
  nextStep: () => void
  previousStep: () => void
  totalSteps: number
}

const WizardContext = createContext<WizardContextProps | undefined>(undefined)

interface WizardProps {
  children: ReactNode
  totalSteps: number
  isWizardOpen: boolean
}

export const Wizard = ({ children, totalSteps, isWizardOpen }: WizardProps) => {
  const [activeStep, setActiveStep] = useState(1)
  const [isOpen, setIsOpen] = useState(isWizardOpen)

  useEffect(() => {
    setIsOpen(isWizardOpen)
    if (!isOpen) {
      setActiveStep(1)
    }
  }, [isWizardOpen, isOpen])

  const nextStep = () => {
    setActiveStep((prevStep) => Math.min(prevStep + 1, totalSteps))
  }

  const previousStep = () => {
    setActiveStep((prevStep) => Math.max(prevStep - 1, 1))
  }

  return (
    <WizardContext.Provider
      value={{ activeStep, nextStep, previousStep, totalSteps }}
    >
      {children}
    </WizardContext.Provider>
  )
}

export const useWizard = () => {
  const context = useContext(WizardContext)
  if (!context) {
    throw new Error('useWizard must be used within a Wizard')
  }
  return context
}
